module.exports = __webpack_public_path__ + "static/media/Reman-starter.148bbfe3.png";